import { SerializedStyles, css } from "@emotion/react";
import { lighten } from "@material-ui/core/styles";

import theme from "../../styles/theme";
import { white, black, greyDark } from "../../styles/variables";

const padding = `${theme.spacing(2)}px`;

export const container = css`
  background: ${white};
`;

export const content = (minWidth?: string): SerializedStyles => css`
  min-width: ${minWidth};
`;

export const header = css`
  display: flex;
  justify-content: space-between;
  padding: ${padding};
  box-shadow: 1px 2px ${lighten(black, 0.9)};
  align-items: center;
`;

export const titleContainer = css`
  display: flex;
  align-items: center;
`;

export const body = css`
  padding: ${padding};
`;

export const btnsContainer = css`
  flex-shrink: 0;
`;

export const btn = css`
  margin-left: ${theme.spacing(1.5)}px;
  height: 40px;
  flex-shrink: 0;
`;

export const text = css`
  font-size: 16px;
  margin-top: auto;
  margin-bottom: auto;
  color: ${greyDark};
`;

export const subtitleText = css`
  margin-top: ${theme.spacing(1.5)}px;
  font-size: 12px;
  color: ${greyDark};
`;
